import DicomParser from "dicom-parser";
// Deflated Explicit VR Little Endian(1.2.840.10008.1.2.1.99) 압축 해제용. jszip 이 같이 설치하는 pako 1.x
import pako from "pako";

/**
 * Deflate 로 압축된 데이터셋을 푼다. dicom-parser 가 메타 헤더 뒤(position)부터를 넘겨준다.
 * 메타 헤더는 그대로 두고 그 뒤를 풀어 이어 붙인 전체 바이트 배열을 돌려줘야 한다.
 */
function inflater(byteArray, position) {
  const inflated = pako.inflateRaw(byteArray.slice(position));
  const fullByteArray = new Uint8Array(position + inflated.length);
  fullByteArray.set(byteArray.slice(0, position), 0);
  fullByteArray.set(inflated, position);
  return fullByteArray;
}

const DicomParserAdapter = {
  parseDicom: (byteArray) => {
    // let dicomData = DicomParser.parseDicom(new Uint8Array(byteArray));
    let dicomData = DicomParser.parseDicom(new Uint8Array(byteArray), {
      inflater,
    });
    ///
    /// HACK : NSTeam parser와 DICOMParser 라이브러리의 호환성 유지를 위해
    /// 집어 넣은 함수. 추후, 좋은 방법이 있다면, 제거하도록하자.
    ///
    dicomData.getElement = function (tag) {
      return this.elements[tag];
    }.bind(dicomData);
    return dicomData;
  },
};
export default DicomParserAdapter;
